<div class="card container-fluid" style="flex: 1 0 auto">
  <div class="row justify-content-between" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
    <div class="col-auto">
      <p-button
        label="Nuevo Negocio"
        icon="pi pi-plus"
        routerLink="/admin/store/create"
      />
    </div>
  </div>

  <div class="container-fluid">
    <p-table
      [value]="ltsStore"
      [tableStyle]="{ 'min-width': '50rem' }"
      responsiveLayout="scroll"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 15, 20, 25]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} de {last} Total {totalRecords} Items"
      styleClass="p-datatable-striped p-datatable-sm"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th id="tbname">Nombre</th>
          <th id="tbphone">Teléfono</th>
          <th id="tbaddress">Dirección</th>
          <th id="tbcity">Ciudad</th>
          <th id="tbstatus">Estado</th>
          <th id="tbfeatured">Destacada</th>
          <th id="tbaction">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-store>
        <tr>
          <td>{{ store.sto_name }}</td>
          <td>{{ store.sto_phone }}</td>
          <td>{{ store.sto_address }}</td>
          <td>{{ store.pd_name }}</td>
          <td>
            <p-tag
              [value]="getStatusConfig(store.sst_id).name"
              [style]="{'background-color': getStatusConfig(store.sst_id).color}"
            />
          </td>
          <td>
            <i
              class="pi"
              [ngClass]="store.sto_is_featured ? 'pi-star-fill text-warning' : 'pi-star text-muted'"
              [pTooltip]="store.sto_is_featured ? 'Destacada' : 'No destacada'"
              tooltipPosition="top"
            ></i>
          </td>
          <td>
            <p-button
              icon="pi pi-eye"
              [rounded]="true"
              [text]="true"
              [severity]="'info'"
              [routerLink]="'/admin/store/detail/' + store.sto_id"
              pTooltip="Ver detalle"
              tooltipPosition="top"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
